/**
 * Minimal entry: no static imports of app/vendor chunks. The browser can evaluate this
 * immediately while jspdf/react-vendor/vendor/motion load as dependencies of main.tsx.
 */
window.__mszBootPhase = "shell:evaluated";
console.info(
  "[MadSportz.boot] STEP 0: shell entry loaded — fetching main application chunk (may include vendor-*, react-vendor-*, jspdf, motion)…",
);

// Listen for service worker updates — dispatch event for UpdatePrompt UI
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.addEventListener('message', (event) => {
    if (event.data?.type === 'SW_UPDATED') {
      // Dispatch custom event so UpdatePrompt.tsx can show a user-facing banner
      // instead of silently reloading mid-workflow
      if (window.__mszReady && window.__mszAppMounted) {
        console.info('[MadSportz] SW updated — notifying UI');
        window.dispatchEvent(new CustomEvent('madsportz:sw-updated'));
      }
    }
    if (event.data?.type === 'USER_CACHE_CLEARED') {
      console.info('[MadSportz] User cache cleared by SW');
    }
  });
}

void import("./main.tsx")
  .then((mod) => {
    window.__mszBootPhase = "shell:main-resolved";
    mod.startBoot();
  })
  .catch((err: unknown) => {
    window.__mszBootFailed = true;
    window.__mszBootPhase = "shell:main-import-failed";
    console.error("[MadSportz.boot] Failed to load main application chunk:", err);
    const root = document.getElementById("root");
    const txt = (root?.innerText ?? "").trim();
    if (!root || !txt.includes("Loading MadSportz")) return;
    const detail =
      err instanceof Error
        ? err.message + (err.stack ? "\n\n" + err.stack : "")
        : String(err);
    root.innerHTML =
      '<div style="min-height:100vh;padding:1.5rem;font-family:system-ui,sans-serif;background:rgb(254, 242, 242);color:rgb(153, 27, 27);max-width:36rem;margin:0 auto">' +
      '<p style="font-weight:600;margin:0 0 0.5rem">Could not load application scripts</p>' +
      '<pre style="white-space:pre-wrap;word-break:break-word;font-size:0.8rem">' +
      detail.replace(/</g, "&lt;") +
      "</pre>" +
      '<p style="margin-top:1rem;font-size:0.8rem;color:rgb(100, 116, 139)">Check Network → JS for a failed or stuck <code>/assets/</code> request. Try <code>?msz_clear_sw=1&msz_no_sw=1</code> once.</p>' +
      "</div>";
  });
